export enum IntroKeys {
  /* intro page */
  intro,

  /* projects page */
  navigator,
  createProject,
  addFiles,
  createStory,

  /* nav-panel */
  navStartTour,
  navProjects,
  navSr,
  navSb,
  navFc,
  navHelpMode,
  navTutorials,

  /* highlights page */
  srSeek,
  srAddClip,
  srGrid,
  srFile,
  srStats,

  /* storyBoard page */
  sbIntro,
  sbAudio,
  sbClip,
  sbPlay,
  sbRender,
  firstBeatMarker,
  startRangeMarker,
  endRangeMarker,
  sbSettings,

  /* sb-tracks */
  storyBoard,
  storyBoardHeader,
  sbAudioHeader,
  clipBoard,
  discardBoard,

  /* finalCuts page */
  fcElem,
  fcPlay,
  fcUpgrade,
  fcDownload,
  fcShare,
}
